import React, { MouseEventHandler } from 'react';
import { Col, Pagination, Row } from 'antd';
import styles from './COPagination.module.scss';
import { ReactComponent as DoubleArrow } from 'assets/icons/double_arrow.svg';
import { ReactComponent as Arrow } from 'assets/icons/arrow_forward.svg';
import clsx from 'clsx';

export interface COPaginationProps {
  onChange: (page: number, pageSize: number) => void;
  total: number;
  pageSize?: number;
  current?: number;
}

enum PaginationTypes {
  SIZE_SMALL = 'small',
  PREV_PAGE = 'prev',
  NEXT_PAGE = 'next',
}

const COPagination: React.FC<COPaginationProps> = ({
  onChange,
  total,
  pageSize,
  current,
}: COPaginationProps) => {
  const size = pageSize ?? 20;
  const lastPage = Math.ceil(total / size);
  const handleJump =
    (last?: boolean): MouseEventHandler<HTMLDivElement> =>
    e => {
      e.stopPropagation();
      onChange(last ? lastPage : 1, size);
    };

  const renderPaginationItem = (
    _: number,
    type: string,
    originalElement: React.ReactNode
  ): React.ReactNode => {
    if (type === PaginationTypes.PREV_PAGE) {
      return (
        <Row align="middle">
          <Col
            className={clsx(styles.leftJump, styles.icon, styles.jumpIcon)}
            onClick={handleJump()}>
            <DoubleArrow />
          </Col>
          <Col className={clsx(styles.leftJump, styles.icon)}>
            <Arrow />
          </Col>
        </Row>
      );
    } else if (type === PaginationTypes.NEXT_PAGE) {
      return (
        <Row align="middle">
          <Col className={styles.icon}>
            <Arrow />
          </Col>
          <Col
            className={clsx(styles.icon, styles.jumpIcon)}
            onClick={handleJump(true)}>
            <DoubleArrow />
          </Col>
        </Row>
      );
    }
    return originalElement;
  };
  return (
    <Row align="middle" gutter={[10, 0]} className={styles.paginationWrapper}>
      <Col>
        <Pagination
          defaultCurrent={1}
          current={current}
          total={total}
          defaultPageSize={size}
          showSizeChanger={false}
          onChange={onChange}
          hideOnSinglePage
          itemRender={renderPaginationItem}
          size={PaginationTypes.SIZE_SMALL}
        />
      </Col>
      {current && lastPage > 1 ? (
        <Col className={styles.pagesInfo}>{`${current}/${lastPage}`}</Col>
      ) : null}
    </Row>
  );
};

export default COPagination;
